import { LeftMenuService } from "./left-menu.service";

export { LeftMenuService };

export default [LeftMenuService];
